import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50",
  role: "dialog",
  "aria-modal": "true"
};
const _hoisted_2 = {
  class: "absolute right-0 top-0 flex h-full w-full max-w-[460px] flex-col bg-white shadow-2xl"
};
const _hoisted_3 = {
  class: "border-b border-slate-200 px-5 py-4"
};
const _hoisted_4 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_5 = {
  class: "min-w-0"
};
const _hoisted_6 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_7 = {
  class: "rounded-lg border border-slate-200 p-4"
};
const _hoisted_8 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_9 = {
  class: "status-badge is-info"
};
const _hoisted_10 = {
  key: 0,
  class: "mt-2 text-xs font-medium text-red-600"
};
const _hoisted_11 = {
  class: "block"
};
const _hoisted_12 = ["placeholder", "disabled"];
const _hoisted_13 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_14 = {
  key: 1,
  class: "mt-0.5 text-xs text-slate-400"
};
const _hoisted_15 = {
  class: "grid grid-cols-1 gap-4 sm:grid-cols-2"
};
const _hoisted_16 = {
  class: "block"
};
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_19 = {
  key: 1,
  class: "mt-0.5 text-xs text-slate-400"
};
const _hoisted_20 = {
  class: "block"
};
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_23 = {
  key: 1,
  class: "mt-0.5 text-xs text-slate-400"
};
const _hoisted_24 = {
  class: "block"
};
const _hoisted_25 = ["disabled"];
const _hoisted_26 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_27 = {
  key: 1,
  class: "mt-0.5 text-xs text-slate-400"
};
const _hoisted_28 = {
  class: "block"
};
const _hoisted_29 = ["placeholder"];
const _hoisted_30 = {
  key: 0,
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_31 = {
  class: "rounded-lg border border-slate-200 p-4"
};
const _hoisted_32 = {
  class: "mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2"
};
const _hoisted_33 = ["onUpdate:modelValue"];
const _hoisted_34 = {
  class: "flex justify-end gap-2 border-t border-slate-200 px-5 py-4"
};
import { computed, reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { formatInvoiceAmount, formatProfitRate, normalizeAmountInput, parsePercentInput, roleLabel, toPercentInput } from '../utils';
export default {
  __name: 'InvoiceNodeEditPanel',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    context: {
      type: Object,
      default: null
    },
    nodeContext: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'saved', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      manualCompanyName: '',
      manualInputAmount: '',
      manualOutputAmount: '',
      manualProfitRatePercent: '',
      productName: '',
      companyLocked: false,
      inputAmountLocked: false,
      outputAmountLocked: false,
      profitRateLocked: false,
      productNameLocked: false
    });
    const initialNodePayload = reactive({
      manualCompanyName: null,
      manualInputAmount: null,
      manualOutputAmount: null,
      manualProfitRate: null,
      productName: null
    });
    const lockFields = [{
      key: 'companyLocked',
      label: '锁定公司名'
    }, {
      key: 'inputAmountLocked',
      label: '锁定进项'
    }, {
      key: 'outputAmountLocked',
      label: '锁定销项'
    }, {
      key: 'profitRateLocked',
      label: '锁定利润率'
    }, {
      key: 'productNameLocked',
      label: '锁定品名'
    }];
    const activeContext = computed(() => props.context || props.nodeContext || null);
    const chain = computed(() => activeContext.value?.chain || null);
    const node = computed(() => activeContext.value?.node || null);
    const isPlatform = computed(() => node.value?.nodeRole === 'PLATFORM' || node.value?.role === 'PLATFORM' || node.value?.platform === true);
    const systemCompanyName = computed(() => firstValue(node.value?.systemCompanyName, node.value?.companyNameSnapshot, node.value?.companyName));
    const manualCompanyName = computed(() => firstValue(node.value?.manualCompanyName));
    const effectiveCompanyName = computed(() => firstValue(node.value?.effectiveCompanyName, manualCompanyName.value, systemCompanyName.value));
    const systemInputAmount = computed(() => firstValue(node.value?.systemInputAmount, node.value?.inputAmount, node.value?.inputInvoiceAmount));
    const manualInputAmount = computed(() => firstValue(node.value?.manualInputAmount));
    const effectiveInputAmount = computed(() => firstValue(node.value?.effectiveInputAmount, manualInputAmount.value, systemInputAmount.value));
    const systemOutputAmount = computed(() => firstValue(node.value?.systemOutputAmount, node.value?.outputAmount, node.value?.outputInvoiceAmount));
    const manualOutputAmount = computed(() => firstValue(node.value?.manualOutputAmount));
    const effectiveOutputAmount = computed(() => firstValue(node.value?.effectiveOutputAmount, manualOutputAmount.value, systemOutputAmount.value));
    const systemProfitRate = computed(() => firstValue(node.value?.systemProfitRate, node.value?.profitRate) || null);
    const manualProfitRate = computed(() => firstValue(node.value?.manualProfitRate) || null);
    const effectiveProfitRate = computed(() => firstValue(node.value?.effectiveProfitRate, manualProfitRate.value, systemProfitRate.value) || null);
    const systemProductName = computed(() => firstValue(node.value?.productName));
    function firstValue(...values) {
      return values.find(value => value !== null && value !== undefined && value !== '') ?? '';
    }
    function cleanText(value) {
      if (value === null || value === undefined) return null;
      const text = String(value).trim();
      return text === '' ? null : text;
    }
    function amountOrNull(value) {
      if (value === null || value === undefined || String(value).trim() === '') return null;
      return normalizeAmountInput(value);
    }
    function resetForm() {
      const current = node.value || {};
      initialNodePayload.manualCompanyName = cleanText(manualCompanyName.value);
      initialNodePayload.manualInputAmount = amountOrNull(manualInputAmount.value);
      initialNodePayload.manualOutputAmount = amountOrNull(manualOutputAmount.value);
      initialNodePayload.manualProfitRate = manualProfitRate.value ?? null;
      initialNodePayload.productName = cleanText(firstValue(current.manualProductName, current.productName));
      form.manualCompanyName = initialNodePayload.manualCompanyName || '';
      form.manualInputAmount = initialNodePayload.manualInputAmount ?? '';
      form.manualOutputAmount = initialNodePayload.manualOutputAmount ?? '';
      form.manualProfitRatePercent = toPercentInput(initialNodePayload.manualProfitRate);
      form.productName = initialNodePayload.productName || '';
      form.companyLocked = Boolean(current.companyLocked);
      form.inputAmountLocked = Boolean(current.inputAmountLocked);
      form.outputAmountLocked = Boolean(current.outputAmountLocked);
      form.profitRateLocked = Boolean(current.profitRateLocked);
      form.productNameLocked = Boolean(current.productNameLocked);
    }
    function closePanel() {
      emit('update:modelValue', false);
    }
    function parseAmountField(value, label) {
      const text = value === null || value === undefined ? '' : String(value).trim();
      if (text === '') return null;
      const amount = Number(text);
      if (!Number.isFinite(amount) || amount <= 0) {
        ElMessage.warning(`${label}必须为正数`);
        return undefined;
      }
      if (amount % 100 !== 0) {
        ElMessage.warning(`${label}必须为 100 元整数倍`);
        return undefined;
      }
      return normalizeAmountInput(amount);
    }
    function submitForm() {
      if (!activeContext.value || !node.value) return;
      if (isPlatform.value && (form.manualCompanyName || form.manualInputAmount || form.manualOutputAmount || form.manualProfitRatePercent)) {
        ElMessage.warning('平台节点不能提交公司、金额或利润率手工修改');
        return;
      }
      const manualInputAmount = isPlatform.value ? null : parseAmountField(form.manualInputAmount, '进项金额');
      if (manualInputAmount === undefined) return;
      const manualOutputAmount = isPlatform.value ? null : parseAmountField(form.manualOutputAmount, '销项金额');
      if (manualOutputAmount === undefined) return;
      const manualProfitRate = isPlatform.value ? null : parsePercentInput(form.manualProfitRatePercent);
      if (!isPlatform.value && form.manualProfitRatePercent && manualProfitRate === null) {
        ElMessage.warning('利润率必须为数字');
        return;
      }
      const nodePayload = {
        manualCompanyName: isPlatform.value ? null : cleanText(form.manualCompanyName),
        manualInputAmount,
        manualOutputAmount,
        manualProfitRate,
        productName: cleanText(form.productName)
      };
      const clearManualFields = [];
      if (!isPlatform.value && initialNodePayload.manualCompanyName !== null && nodePayload.manualCompanyName === null) {
        clearManualFields.push('manualCompanyName');
      }
      if (!isPlatform.value && initialNodePayload.manualInputAmount !== null && manualInputAmount === null) {
        clearManualFields.push('manualInputAmount');
      }
      if (!isPlatform.value && initialNodePayload.manualOutputAmount !== null && manualOutputAmount === null) {
        clearManualFields.push('manualOutputAmount');
      }
      if (!isPlatform.value && initialNodePayload.manualProfitRate !== null && manualProfitRate === null) {
        clearManualFields.push('manualProfitRate');
      }
      if (clearManualFields.length > 0) {
        nodePayload.clearManualFields = clearManualFields;
      }
      const hasNodeChanges = !isPlatform.value && (nodePayload.manualCompanyName !== initialNodePayload.manualCompanyName || nodePayload.manualInputAmount !== initialNodePayload.manualInputAmount || nodePayload.manualOutputAmount !== initialNodePayload.manualOutputAmount || nodePayload.manualProfitRate !== initialNodePayload.manualProfitRate || nodePayload.productName !== initialNodePayload.productName || clearManualFields.length > 0);
      const payload = {
        chain: chain.value,
        node: node.value,
        nodePayload: hasNodeChanges ? nodePayload : null,
        locks: {
          companyLocked: form.companyLocked,
          inputAmountLocked: form.inputAmountLocked,
          outputAmountLocked: form.outputAmountLocked,
          profitRateLocked: form.profitRateLocked,
          productNameLocked: form.productNameLocked
        }
      };
      emit('saved', payload);
      emit('submit', payload);
    }
    watch([activeContext, () => props.modelValue], () => {
      if (props.modelValue) resetForm();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [__props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/40",
        onClick: closePanel
      }), _createElementVNode("aside", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[5] || (_cache[5] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "编辑链路节点", -1)), _createElementVNode("p", _hoisted_6, _toDisplayString(isPlatform.value ? '平台节点仅支持锁定品名' : '手工值优先生效，留空使用系统值'), 1)]), _createElementVNode("button", {
        type: "button",
        class: "table-action-button is-neutral",
        title: "关闭",
        "aria-label": "关闭",
        onClick: closePanel
      }, [_createVNode(_unref(XMarkIcon), {
        class: "h-4 w-4"
      })])])]), _createElementVNode("form", {
        class: "min-h-0 flex-1 space-y-5 overflow-y-auto px-5 py-4",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [_createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
        class: _normalizeClass(['status-badge', isPlatform.value ? 'is-indigo ' : 'is-neutral '])
      }, _toDisplayString(isPlatform.value ? '平台' : _unref(roleLabel)(node.value?.nodeRole || node.value?.role)), 3), _createElementVNode("span", _hoisted_9, "链路 " + _toDisplayString(chain.value?.chainNo || '-'), 1)]), node.value?.invalidReason ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(node.value.invalidReason), 1)) : _createCommentVNode("", true)]), _createElementVNode("label", _hoisted_11, [_cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "form-label"
      }, "公司名", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.manualCompanyName = $event),
        class: "form-input mt-1 w-full",
        placeholder: systemCompanyName.value || '留空使用系统公司名',
        disabled: isPlatform.value
      }, null, 8, _hoisted_12), [[_vModelText, form.manualCompanyName, void 0, {
        trim: true
      }]]), effectiveCompanyName.value ? (_openBlock(), _createElementBlock("p", _hoisted_13, "当前生效值：" + _toDisplayString(effectiveCompanyName.value), 1)) : _createCommentVNode("", true), systemCompanyName.value ? (_openBlock(), _createElementBlock("p", _hoisted_14, "系统值：" + _toDisplayString(systemCompanyName.value), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("label", _hoisted_16, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "form-label"
      }, "进项金额", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.manualInputAmount = $event),
        class: "form-input mt-1 w-full",
        inputmode: "decimal",
        placeholder: "100 元整数倍",
        disabled: isPlatform.value
      }, null, 8, _hoisted_17), [[_vModelText, form.manualInputAmount, void 0, {
        trim: true
      }]]), effectiveInputAmount.value ? (_openBlock(), _createElementBlock("p", _hoisted_18, "当前生效值：" + _toDisplayString(_unref(formatInvoiceAmount)(effectiveInputAmount.value)), 1)) : _createCommentVNode("", true), systemInputAmount.value ? (_openBlock(), _createElementBlock("p", _hoisted_19, "系统值：" + _toDisplayString(_unref(formatInvoiceAmount)(systemInputAmount.value)), 1)) : _createCommentVNode("", true)]), _createElementVNode("label", _hoisted_20, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "form-label"
      }, "销项金额", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.manualOutputAmount = $event),
        class: "form-input mt-1 w-full",
        inputmode: "decimal",
        placeholder: "100 元整数倍",
        disabled: isPlatform.value
      }, null, 8, _hoisted_21), [[_vModelText, form.manualOutputAmount, void 0, {
        trim: true
      }]]), effectiveOutputAmount.value ? (_openBlock(), _createElementBlock("p", _hoisted_22, "当前生效值：" + _toDisplayString(_unref(formatInvoiceAmount)(effectiveOutputAmount.value)), 1)) : _createCommentVNode("", true), systemOutputAmount.value ? (_openBlock(), _createElementBlock("p", _hoisted_23, "系统值：" + _toDisplayString(_unref(formatInvoiceAmount)(systemOutputAmount.value)), 1)) : _createCommentVNode("", true)])]), _createElementVNode("label", _hoisted_24, [_cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "form-label"
      }, "利润率（%）", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.manualProfitRatePercent = $event),
        class: "form-input mt-1 w-full",
        inputmode: "decimal",
        placeholder: "例如 6.50",
        disabled: isPlatform.value
      }, null, 8, _hoisted_25), [[_vModelText, form.manualProfitRatePercent, void 0, {
        trim: true
      }]]), effectiveProfitRate.value !== null ? (_openBlock(), _createElementBlock("p", _hoisted_26, "当前生效值：" + _toDisplayString(_unref(formatProfitRate)(effectiveProfitRate.value)), 1)) : _createCommentVNode("", true), systemProfitRate.value !== null ? (_openBlock(), _createElementBlock("p", _hoisted_27, "系统值：" + _toDisplayString(_unref(formatProfitRate)(systemProfitRate.value)), 1)) : _createCommentVNode("", true)]), _createElementVNode("label", _hoisted_28, [_cache[10] || (_cache[10] = _createElementVNode("span", {
        class: "form-label"
      }, "品名", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.productName = $event),
        class: "form-input mt-1 w-full",
        placeholder: systemProductName.value || '请输入开票品名'
      }, null, 8, _hoisted_29), [[_vModelText, form.productName, void 0, {
        trim: true
      }]]), systemProductName.value ? (_openBlock(), _createElementBlock("p", _hoisted_30, "当前生效值：" + _toDisplayString(systemProductName.value), 1)) : _createCommentVNode("", true)]), _createElementVNode("section", _hoisted_31, [_cache[11] || (_cache[11] = _createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-900"
      }, "字段锁定", -1)), _createElementVNode("div", _hoisted_32, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(lockFields, item => {
        return _createElementVNode("label", {
          key: item.key,
          class: "flex items-center gap-2 text-sm text-slate-700"
        }, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => form[item.key] = $event,
          type: "checkbox",
          class: "form-check"
        }, null, 8, _hoisted_33), [[_vModelCheckbox, form[item.key]]]), _createTextVNode(" " + _toDisplayString(item.label), 1)]);
      }), 64))])])], 32), _createElementVNode("footer", _hoisted_34, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: closePanel
      }, "取消"), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-primary",
        onClick: submitForm
      }, [...(_cache[12] || (_cache[12] = [_createTextVNode("保存", -1)]))])), [[_directive_permission, 'enterprise-invoice:chain:edit']])])])])), [[_directive_modal_a11y, closePanel]]) : _createCommentVNode("", true)]);
    };
  }
};